import { Fragment } from "react";
import { Card, CardBody, Col, Input, Label, Row } from "reactstrap";
import CommonCardHeader from "../../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { AnimatedButtonsTitle } from "../../../../../../Constants/Constants";
import { AnimatedButtonsData, AnimatedButtonsSubTitle } from "../../../../../../Data/Forms&Table/Forms/FormControls";
import { H6 } from "../../../../../../AbstractElements";

const AnimatedButtons = () => {
  return (
    <Col xl="6" className="animate_btn_custom">
      <Card className="height-equal">
        <CommonCardHeader title={AnimatedButtonsTitle} span={AnimatedButtonsSubTitle} />
        <CardBody>
          <Row className="g-3">
            {AnimatedButtonsData.map((data) => (
              <Col sm="6" key={data.id}>
                <div className="card-wrapper border rounded-3 checkbox-checked">
                  <H6 className="sub-title">{data.title}</H6>
                  {data.child.map((item) => (
                    <Fragment key={item.id}>
                      <Label className="d-block"></Label>
                      <Input className={`${item.type}_animated`} type={item.type} defaultChecked={item.check === "checked"} name={item.type === "radio" ? item.name : ""} />
                      {item.text}
                    </Fragment>
                  ))}
                </div>
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
export default AnimatedButtons;
